var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudentId(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "20px",
    viewBox: "0 0 22 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "256F8C8F-4275-460D-A235-F9E712D2F3E2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Week-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Application-Summary-Cards",
    transform: "translate(-385.000000, -4099.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(360.000000, 4069.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-/-student-id",
    transform: "translate(24.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5,6 L9.5,2.99703014 C9.5,2.4463856 9.94371665,2 10.4998075,2 L13.5001925,2 C14.0523709,2 14.5,2.44725688 14.5,2.99703014 L14.5,6 L20.999095,6 C22.1041643,6 23,6.89451376 23,8.00212885 L23,19.9978711 C23,21.1036164 22.1034544,22 20.999095,22 L3.000905,22 C1.89583568,22 1,21.1054862 1,19.9978711 L1,8.00212885 C1,6.89638362 1.89654562,6 3.000905,6 L9.5,6 Z M3,8 L3,20 L21,20 L21,8 L14.5,8 L14.5,9.00296986 C14.5,9.5536144 14.0562834,10 13.5001925,10 L10.4998075,10 C9.94762906,10 9.5,9.55274312 9.5,9.00296986 L9.5,8 L3,8 Z M6,13 C6,11.8954305 6.8954305,11 8,11 C9.1045695,11 10,11.8954305 10,13 C10,13.6209944 9.7169774,14.4919596 9.27288519,15.1355456 L10.5513357,15.7754348 C10.7991262,15.8994588 11,16.2216766 11,16.5046844 L11,17 C11,17.5522847 10.5490248,18 9.9957349,18 L6.0042651,18 C5.4496248,18 5,17.5561352 5,17 L5,16.5046844 C5,16.2259549 5.19704262,15.9015808 5.44311964,15.7786698 L6.72803476,15.1368782 C6.2834135,14.4931622 6,13.6214231 6,13 Z M11.5,4 L11.5,8 L12.5,8 L12.5,4 L11.5,4 Z M12,13 C12,12.4477153 12.4485301,12 13.0029293,12 L17.9970707,12 C18.5509732,12 19,12.4438648 19,13 C19,13.5522847 18.5514699,14 17.9970707,14 L13.0029293,14 C12.4490268,14 12,13.5561352 12,13 Z M12,16 C12,15.4477153 12.4437166,15 12.9998075,15 L16.0001925,15 C16.5523709,15 17,15.4438648 17,16 C17,16.5522847 16.5562834,17 16.0001925,17 L12.9998075,17 C12.4476291,17 12,16.5561352 12,16 Z",
    id: "path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentId);
export default __webpack_public_path__ + "static/media/student-id.2bac21acf0f014d873ddbd325bd639f4.svg";
export { ForwardRef as ReactComponent };